import * as React from "react";
import { bugsnagClient } from "../../bugsnag/bugsnagClient";
import { componentWithProps } from "../../generic/componentWithProps";
import { ErrorBoundary } from "../../generic/ErrorBoundary";
import { createHudLayout } from "../../hud/createHudLayout";
import { IdHudLayout } from "../../hud/IdHudLayout";
import { BF2HudBottom } from "./BF2HudBottom";
import { BF2HudBottomLeft } from "./BF2HudBottomLeft";
import { BF2HudBottomRight } from "./BF2HudBottomRight";
import { BF2HudLeft } from "./BF2HudLeft";
import { BF2HudLeftTop } from "./BF2HudLeftTop";
import { BF2HudRight } from "./BF2HudRight";
import { BF2HudRightTop } from "./BF2HudRightTop";
import { BF2HudTop } from "./BF2HudTop";
import { BF2HudTopLeft } from "./BF2HudTopLeft";
import { BF2HudTopRight } from "./BF2HudTopRight";
var hudLayoutMap = new Map([
    // Top
    [IdHudLayout.topLeft, React.createElement(BF2HudTopLeft, null)],
    [IdHudLayout.top, React.createElement(BF2HudTop, null)],
    [IdHudLayout.topRight, React.createElement(BF2HudTopRight, null)],
    // Center
    [IdHudLayout.leftTop, React.createElement(BF2HudLeftTop, null)],
    [IdHudLayout.left, React.createElement(BF2HudLeft, null)],
    [IdHudLayout.rightTop, React.createElement(BF2HudRightTop, null)],
    [IdHudLayout.right, React.createElement(BF2HudRight, null)],
    [IdHudLayout.center, React.createElement(React.Fragment, null)],
    // Bottom
    [IdHudLayout.bottomLeft, React.createElement(BF2HudBottomLeft, null)],
    [IdHudLayout.bottom, React.createElement(BF2HudBottom, null)],
    [IdHudLayout.bottomRight, React.createElement(BF2HudBottomRight, null)],
]);
var HudLayoutIds = [
    IdHudLayout.topLeft,
    IdHudLayout.top,
    IdHudLayout.topRight,
    IdHudLayout.leftTop,
    IdHudLayout.left,
    IdHudLayout.center,
    IdHudLayout.rightTop,
    IdHudLayout.right,
    IdHudLayout.bottomLeft,
    IdHudLayout.bottom,
    IdHudLayout.bottomRight,
];
export var BF2HudPlayerBaseDOM = function () {
    return componentWithProps({
        ComponentType: createHudLayout(HudLayoutIds, "hud-player-base"),
        children: function (id) { return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "BF2HudPlayerBaseDOM.tsx" }, hudLayoutMap.get(id))); },
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/hud/BF2HudPlayerBaseDOM.tsx
// module id = 2260
// module chunks = 3